// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"227":"e22e9038","232":"46b1598c","237":"12b49d6a","526":"16214312"}[chunkId] + ".chunk.js";
};